import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, getDocs, collection, onSnapshot } from "firebase/firestore"; // Add Firestore imports
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
/* import { getAnalytics } from "firebase/analytics"; */

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app); // Firestore initialization
export const auth = getAuth(app);
export const storage = getStorage(app);
// const analytics = getAnalytics(app);

// Export Firestore methods to be used elsewhere
export { doc, getDoc, getDocs, collection, onSnapshot};
